import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import BaseMixin from "./BaseMixin";
import Styles from "../StyleSheet";

const KeypressTerminal = createReactClass({
  propTypes: {
    node: PropTypes.object,
    editable: PropTypes.bool
  },

  displayName: "Keypress",
  mixins: [BaseMixin],

  onValueChange: function(event) {
    this.props.node.set("value", event.target.value);
  },

  triggerValidation: function() {
    this.props.node.trigger("validate");
  },

  render: function() {
    return (
      <form className="form-inline">
        {this.renderTerminalName()}
        <div className="form-group">
          <input
            className="form-control"
            value={this.props.node.get('value')}
            onChange={this.onValueChange}
            onBlur={this.triggerValidation}
            style={{ width: this.props.editable ? "100px" : "auto", ...Styles.lastChild }}
            disabled={!this.props.editable}
          />
        </div>
      </form>
    );
  }
});

export default KeypressTerminal;
